import React from "react";

export default function LeftPreviewArrow({
  size = 16,
  color = "#7498CF",
}: {
  readonly size?: number;
  readonly color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45 21L30 36L45 51"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}